import React from 'react';

import { format } from 'date-fns';
import { Table } from 'reactstrap';
import utils from '../../lib/utils';

const ThirdSection = ({ date, billingAddress, co, phone, companyField }) => {
  return (
    <div className="loa-doc-page">
      <h2 className="loa-doc-title">Customer Contact Authorization</h2>
      <h3 className="loa-doc-subtitle loa-doc-subtitle_normal">
        CPNI – Customer Proprietary Network Information
      </h3>
      <p className="loa-doc-date">
        Date: {utils.getDateTimeFormat(date ? date : new Date(), 'regular')}
      </p>
      <p>
        I, the above-signed customer, by signing the EPIK Proposal on page 1 of this documentation
        package hereby grant permission to EPIK to provide information to the following parties
        until revoked in writing for the purpose of servicing my telecommunications account,
        including: the review of network, service, and billing records; negotiation of service
        changes; and resolution of network and billing issues that may arise on my account.
      </p>
      <Table bordered size="sm" className="legal-company-table">
        <tr>
          <td style={{ width: '25%' }} className="legal-company-table-header">
            Legal Company Name:
          </td>
          <td colSpan={5}>{companyField && companyField.companyName}</td>
        </tr>
        <tr>
          <td style={{ width: '25%' }} className="legal-company-table-header">
            DBA:
          </td>
          <td colSpan={5}></td>
        </tr>
        <tr>
          <td style={{ width: '25%' }} className="legal-company-table-header">
            Billing Address Street:
          </td>
          <td colSpan={5}>
            {billingAddress ? billingAddress.address1 + ' ' + billingAddress.address2 : ''}
          </td>
        </tr>
        <tr>
          <td style={{ width: '25%' }} className="legal-company-table-header">
            City:
          </td>
          <td>{billingAddress ? billingAddress.city : ''}</td>
          <td style={{ width: '10%' }} className="legal-company-table-header">
            State:
          </td>
          <td style={{ width: '10%' }}>{billingAddress ? billingAddress.state : ''}</td>
          <td style={{ width: '15%' }} className="legal-company-table-header">
            Zip:
          </td>
          <td>{billingAddress ? billingAddress.zip : ''}</td>
        </tr>
      </Table>
      <p>
        <b>Identified below are parties I have authorized as account contacts:</b>
      </p>
      <div className="flex-center">
        <Table bordered className="users-small-table" size="sm">
          <thead>
            <tr>
              <th>Authorized Users</th>
              <th>Contact Information</th>
            </tr>
          </thead>
          <tbody>
            <tr style={{ fontWeight: 'bold' }}>
              <td>EPIK Project Management Department</td>
              <td>(949) 544-1050</td>
            </tr>
            <tr style={{ fontWeight: 'bold' }}>
              <td>EPIK Engineering Department</td>
              <td>(949) 892-8885</td>
            </tr>
            <tr style={{ fontWeight: 'bold' }}>
              <td>{companyField ? companyField.firstName + ' ' + companyField.lastName : ''}</td>
              <td>{companyField && companyField.contact}</td>
            </tr>
            <tr>
              <td></td>
              <td></td>
            </tr>
            <tr>
              <td></td>
              <td></td>
            </tr>
          </tbody>
        </Table>
      </div>
      <p>
        <b>This CPNI contact authorization applies to each of the following carrier accounts:</b>
      </p>
      <div className="flex-center">
        <Table bordered className="carrier-account-table" size="sm">
          <thead>
            <tr>
              <th style={{ width: '35%' }}>Carrier</th>
              <th style={{ width: '30%' }}>Carrier Account Number</th>
              <th style={{ width: '35%' }}>Your PIN</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td></td>
              <td></td>
              <td></td>
            </tr>
            <tr>
              <td></td>
              <td></td>
              <td></td>
            </tr>
            <tr>
              <td></td>
              <td></td>
              <td></td>
            </tr>
          </tbody>
        </Table>
      </div>
      <p>
        EPIK is committed to protecting your proprietary telecommunications information which is
        known as Customer Proprietary Network Information (CPNI). Please assist us by providing
        complete contact information for parties authorized to receive information regarding your
        account so we may provide EPIK services to you.
      </p>
      <p>
        Signatures transmitted and delivered via facsimile, scanned and electronically delivered or
        signed electronically and electronically delivered, shall be treated for all purposes of the
        LOA as original signatures and shall be deemed valid, binding and enforceable.
      </p>
    </div>
  );
};

export default ThirdSection;
